var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{staticClass:"relative"},[_c('div',{staticClass:"profile_image mt-6 bg-center bg-cover rounded-lg bg-no-repeat",style:({ backgroundImage: 'url(' + _vm.src + ')'})})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }